import { post } from '../apiService';

export const postSupportRequest = data => {
  return post('/support/', data);
};
